// src/components/GamePopups.js
import React from 'react';
import styles from '../views/GameCommon.module.css'; // We will create this common CSS file

/**
 * Renders the Streak and Encouragement popups.
 * This component is purely for UI display based on props.
 *
 * @param {object} props - The component props.
 * @param {boolean} props.showStreakPopup - Whether the streak popup should be visible.
 * @param {string} props.streakMessage - The message to display in the streak popup.
 * @param {boolean} props.showEncouragementPopup - Whether the encouragement popup should be visible.
 * @param {string} props.encouragementMessage - The message to display in the encouragement popup.
 */
const GamePopups = ({
                        showStreakPopup,
                        streakMessage,
                        showEncouragementPopup,
                        encouragementMessage,
                    }) => {
    return (
        <>
            {showStreakPopup && (
                <div className={styles.streakPopup}>
                    <p>{streakMessage}</p>
                </div>
            )}

            {showEncouragementPopup && (
                <div className={styles.encouragementPopup}>
                    <p>{encouragementMessage}</p>
                </div>
            )}
        </>
    );
};

export default GamePopups;
